import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { LOCALE_ID } from '@angular/core';
import { MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { AnnouncementsComponent } from './components/announcements/announcements.component';
import { MakeAdjustmentComponent } from './components/make-adjustment/make-adjustment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxEditorModule } from 'ngx-editor';

import { MangementComponent } from './components/mangement/mangement.component';
import { CrmComponent } from './components/crm/crm.component';
import { ReportModule } from '../report/report.module';
import {
  ImgExifService,
  ImgMaxPXSizeService,
  ImgMaxSizeService,
  Ng2ImgMaxService,
  Ng2ImgMaxModule,
} from 'ng2-img-max';
import { ProfileModule } from './components/crm/profile/profile.module';
import { ReCaptchaModule } from 'angular-recaptcha3';
import constantURL from '../../../shared/constantURL';
import { ManualPaymentComponent } from './components/manual-payment/manual-payment.component';
import { ActionRoutingModule } from './action-routing.module';
import { PromocodeModule } from './components/promocode/promocode.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@NgModule({
  declarations: [
    AnnouncementsComponent,
    MakeAdjustmentComponent,
    MangementComponent,
    CrmComponent,
    ManualPaymentComponent,
  ],
  imports: [
    CommonModule,
    ActionRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    ProfileModule,
    PromocodeModule,
    FormsModule,
    ReportModule,
    MatDialogModule,
    MatCheckboxModule,
    MatRadioModule,
    MatButtonModule,
    MatListModule,
    MatTabsModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    Ng2ImgMaxModule,
    NgxEditorModule.forRoot({
      locals: {
        // menu
        bold: 'Bold',
        italic: 'Italic',
        code: 'Code',
        blockquote: 'Blockquote',
        underline: 'Underline',
        strike: 'Strike',
        bullet_list: 'Bullet List',
        ordered_list: 'Ordered List',
        heading: 'Heading',
        h1: 'Header 1',
        h2: 'Header 2',
        h3: 'Header 3',
        h4: 'Header 4',
        h5: 'Header 5',
        h6: 'Header 6',
        align_left: 'Left Align',
        align_center: 'Center Align',
        align_right: 'Right Align',
        align_justify: 'Justify',
        text_color: 'Text Color',
        background_color: 'Background Color',

        // popups, forms, others...
        url: 'URL',
        text: 'Text',
        openInNewTab: 'Open in new tab',
        insert: 'Insert',
        altText: 'Alt Text',
        title: 'Title',
        remove: 'Remove',
      },
    }),
    ReCaptchaModule.forRoot({
      invisible: {
        sitekey: constantURL.RECAPTCHA_KEY,
      },
      normal: {
        sitekey: constantURL.RECAPTCHA_KEY,
      },
      language: 'en',
    }),
  ],
  providers: [
    Ng2ImgMaxService,
    ImgMaxSizeService,
    ImgExifService,
    ImgMaxPXSizeService,
    { provide: LOCALE_ID, useValue: 'en-GB' },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class ActionModule {}
